// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import FireDepartmentListResultModel from '../../model/fire-department-list-result-model';
import FireDepartmentListResultDTO from '../dto/fire-department-list-result-dto';
import dtoSchema from '../schemas/fire-department-list-result-schema';
import FireDepartmentModel from '../../model/fire-department-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class FireDepartmentListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<FireDepartmentListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => FireDepartmentModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: FireDepartmentModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<FireDepartmentListResultDTO>): FireDepartmentListResultModel;
  static toModel(dto: DeepPartial<FireDepartmentListResultDTO> | undefined | null): FireDepartmentListResultModel | undefined;
  static toModel(dto: DeepPartial<FireDepartmentListResultDTO> | undefined | null): FireDepartmentListResultModel | undefined {
    return dto ? new FireDepartmentListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<FireDepartmentListResultModel> | FireDepartmentListResultModel): FireDepartmentListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as FireDepartmentListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for FireDepartmentListResultModel, can not map to FireDepartmentListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
